module.exports = __webpack_public_path__ + "img/intro1.c0c0bed6.png";